/* Lengvi video (snippets/tfi-video.liquid): šaltinis įrašomas tik priartėjus prie video,
   autoplay video groja tik matomi. Paslėpti (display:none) nesikrauna visai. */
(() => {
  const SEL = 'video[data-tfi-video]';

  const load = (v) => {
    if (v.dataset.tfiLoaded) return;
    v.dataset.tfiLoaded = '1';
    if (v.dataset.poster) v.poster = v.dataset.poster;
    v.querySelectorAll('source[data-src]').forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    v.load();
  };

  // kraunam priartėjus 300 px, o grojam tik matomus (greitis_fi.py: mažiau dekodavimo slenkant telefone)
  const near = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        load(e.target);
        near.unobserve(e.target);
      }
    },
    { rootMargin: '300px 0px' }
  );

  const seen = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        const v = e.target;
        if (e.isIntersecting) {
          load(v);
          if (v.hasAttribute('data-autoplay') && v.paused) v.play().catch(() => {});
        } else if (v.dataset.tfiLoaded && !v.paused) {
          v.pause();
        }
      }
    },
    { threshold: 0.15 }
  );

  const watch = (v) => {
    if (v.dataset.tfiObserved) return;
    v.dataset.tfiObserved = '1';
    near.observe(v);
    seen.observe(v);
  };

  document.querySelectorAll(SEL).forEach(watch);

  // deferred-media ir kiti komponentai video įdeda vėliau (iš <template>)
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches(SEL)) watch(n);
        n.querySelectorAll?.(SEL).forEach(watch);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
